import { IconName } from './Icon.types';

export { default as Icon } from './Icon';
export { iconNames, isIconName } from './utils';
export type { IconName };
